import {AfterViewInit, Directive, ElementRef, Input} from '@angular/core';


@Directive({
    selector: '[appWidth]'
})
export class WidthDirective implements AfterViewInit {
    @Input('appWidth') elementWidth: number | string;

    constructor(private el: ElementRef) {
    }

    ngAfterViewInit(): void {
        this.el.nativeElement.style.width = `${this.elementWidth}px`;
    }
}
